import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Button,
  EmptyState,
  ErrorState,
  LoadingState,
  PageHeader,
  StatusBadge,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui'
import { useProduct } from './api/contractsApi.ts'
import { ProductFormModal } from './components/ProductFormModal.tsx'
import { TariffsSection } from './sections/TariffsSection.tsx'

export function ProductDetailPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [editOpen, setEditOpen] = useState(false)
  const { data: product, isLoading, error, refetch } = useProduct(id)

  if (isLoading || !id) return <LoadingState label="Lade Produkt …" />
  if (error) {
    return (
      <ErrorState
        description="Produkt konnte nicht geladen werden."
        details={error instanceof Error ? error.message : String(error)}
        onRetry={() => void refetch()}
      />
    )
  }
  if (!product) return <EmptyState title="Produkt nicht gefunden" />

  return (
    <div className="space-y-4">
      <PageHeader
        title={product.name}
        description={product.sku ? `SKU ${product.sku}` : 'Vertragsbaustein'}
        breadcrumbs={[
          { label: 'Hauptmenü', to: '/dashboard' },
          { label: 'Verträge', to: '/vertraege' },
          { label: product.name },
        ]}
        actions={
          <div className="flex items-center gap-2">
            <StatusBadge status={product.active ? 'active' : 'inactive'} />
            <Button variant="secondary" size="sm" onClick={() => setEditOpen(true)}>
              Stammdaten bearbeiten
            </Button>
            <Button variant="ghost" size="sm" onClick={() => navigate('/vertraege')}>
              Zurück
            </Button>
          </div>
        }
      />

      <Tabs defaultValue="tarife">
        <TabsList>
          <TabsTrigger value="tarife">Tarife &amp; Preisstaffeln</TabsTrigger>
          <TabsTrigger value="stamm">Stammdaten</TabsTrigger>
        </TabsList>

        <TabsContent value="tarife">
          <TariffsSection productId={id} productUnit={product.unit} />
        </TabsContent>

        <TabsContent value="stamm">
          <div className="text-small text-gray-600">
            Stammdaten werden über den Button „Stammdaten bearbeiten" oben gepflegt — Modal mit allen
            Feldern inklusive SAP-Artikel-Brücke und Portal-SKUs.
          </div>
        </TabsContent>
      </Tabs>

      <ProductFormModal
        open={editOpen}
        onOpenChange={setEditOpen}
        product={product}
        onSaved={() => {
          setEditOpen(false)
          void refetch()
        }}
      />
    </div>
  )
}
